import {
  FilterDocument,
  FilterDocumentDateCustomTypes,
  FilterDocumentDateFilter,
  FilterDocumentDateFilterTypes,
  FilterOptionKeys,
} from '@griply/types';

export const buildCalendarTaskFilterDocument = (
  base: FilterDocument,
  window: { start: Date; end: Date },
): FilterDocument => {
  const windowFilter: FilterDocumentDateFilter = {
    type: FilterDocumentDateFilterTypes.Custom,
    custom: {
      type: FilterDocumentDateCustomTypes.Between,
      start: window.start,
      end: window.end,
    },
  };

  const baseBranches = base.or?.length ? base.or : [{}];
  const or = baseBranches.flatMap((branch) => [
    { ...branch, [FilterOptionKeys.Date]: windowFilter },
    { ...branch, [FilterOptionKeys.Deadline]: windowFilter },
  ]);

  // The calendar renders completed occurrences itself (hideCompleted in
  // getTasksCalendarEvents), so the sourcing filter must not drop schedule
  // tasks whose in-window occurrences are all completed. In-memory only,
  // never persisted — same as buildHabitsFilterDocument.
  return { ...base, showCompletedForDate: true, or };
};
